import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DataSourceValueStringBase } from "abweb/dto/generated/ds/DataSourceValueStringBase";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { NumberUtils } from "abweb/utils/NumberUtils";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceValueString extends DataSourceValueStringBase {
  /**
   * Simplified factory method for creating a DataSourceValueString in a NORMAL state with no baseline.
   * @param id
   * @param value
   * @param refID
   * @returns {DataSourceReference}
   */
  static createWithReadOnlyDefaults(id, value, refID = null) {
    return DataSourceValueString.createDataSourceValueString(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, id, /*baselineRefID*/null, refID, /*state*/DataSourceState.NORMAL, /*baseline*/null, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
  }
  static createDataSourceValueString(attributeValues, clientTag, dataSourceSaveAction, id, baselineRefID, refID, state, baseline, value, editableOverwrite = null, fieldTypeOverwrite = null) {
    const retVal = new DataSourceValueString();
    retVal.initDataSourceValueString(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, null, value);
    return retVal;
  }

  /* override */
  initDataSourceValueString(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value) {
    super.initDataSourceValueString(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value);
    if (currentValue == null) {
      this.currentValue = value;
    }
  }
  constructor() {
    super();
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.value;
  }
  getBaseline() {
    return this.baseline;
  }
  getDisplayValue() {
    // In this case, the displayValue is the value.  Maybe make it safe for HTML?
    const s = this.get("currentValue");
    return s || "";
  }

  // @Override
  isEmpty() {
    const s = this.getString();
    return s == null || s.length === 0;
  }
  get isString() {
    return this.fieldType === DataFieldTypeEnum.STRING;
  }
  get isText() {
    return this.fieldType === DataFieldTypeEnum.TEXT;
  }

  // @override
  validateValue(value) {
    const s = value ? value : "";
    const error = super.validateValue(value);
    if (error != null) {
      return error;
    }
    if (this._field == null || this._field.validation == null) {
      // Nothing to validate
      return null;
    }
    const validation = this._field.validation;

    // maxLength
    if (validation.maxLength && !isNaN(validation.maxLength) && validation.maxLength > 0) {
      if (s.length > validation.maxLength) {
        return AbWebResources.maxLengthValidation((validation.maxLength + 1).toString());
      }
    }

    // regExp
    if (validation.regExp != null) {
      if (!validation.regExp.test(s)) {
        // No match found so this is bad
        if (validation.patternMatchDisplayMessage == null) {
          // use generic patternMatch failure message
          return AbWebResources.regExpValidation(validation.patternMatch ? validation.patternMatch : "");
        } else {
          return validation.patternMatchDisplayMessage;
        }
      }
    }
    return null;
  }
  getString() {
    return this.currentValue;
  }
  coerceValue(value) {
    if (value == null) {
      return null;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      // Note that we leave null as null
      value = value.getCurrentValue() == null ? null : value.getDisplayValue();
    }
    if (value == null) {
      return null;
    }
    const t = typeof value;
    if (t === "string") {
      return value;
    }
    if (t === "number") {
      return NumberUtils.formatValue(value);
    }
    if (ClassUtils.isInstanceOf(value, Date)) {
      return DateTimeUtils.DATE_SHORT.format(value);
    }
    return value.toString();
  }
  initializeWithDefaultFieldValue(field) {
    if (field.defaultValue == null) {
      return;
    }
    this.value = this.currentValue = field.defaultValue;
  }
}
//# sourceMappingURL=DataSourceValueString.js.map
